import LxcError from "~/core/models/LxcError.class";
import operationManagerService from "~/core/services/operationManager.service";
import type { DtwinUpdateOperation } from "~/modules/dtwin/models/DtwinUpdateOperation.interface";

export function useUpdateOperationConfiguration({
  organizationCode,
}: {
  organizationCode?: number;
}) {
  const isLoading = ref(false);
  const error: Ref<LxcError | undefined> = ref();

  async function updateOperation(
    operationUid: string,
    operation: DtwinUpdateOperation,
  ) {
    if (!organizationCode) {
      throw new Error("Organization code is undefined");
    }
    isLoading.value = true;
    error.value = undefined;

    const response = await operationManagerService.updateOperation(
      organizationCode,
      operationUid,
      operation,
    );

    if (LxcError.check(response)) {
      error.value = response;
    }

    isLoading.value = false;
  }

  return {
    updateOperation,
    isLoading,
    error,
  };
}
